import { useRouter } from 'next/router';

import { Box } from '@zillow/constellation-10';

import { formatAddress } from '@zg-rentals/zillow-rental-manager/utils';

import { useGetListingDetails } from '../../../hooks/queries/properties';
import { useFieldSave } from '../../../hooks/useFieldSave';
import { useMultiEditMutation } from '../../../hooks/useMultiEditMutation';
import { getIsInputFormDisabled } from '../../MFAccordion/utils';

import { useAuth } from '../../AuthProvider';
import RMWInput from '../../RMWInput';

const inputName = 'unit';

const AddressFormField = () => {
  const router = useRouter();
  const { user } = useAuth();

  const listingAlias = router.query.listingAlias as string;
  const { data: listingDetails } = useGetListingDetails(listingAlias);

  const initialUnit = listingDetails?.unit ?? '';

  const isInputDisabled = getIsInputFormDisabled(listingDetails, user?.features?.canUpdateListing ?? false);

  const { formattedAddressWithoutUnit } = formatAddress({
    street: listingDetails?.street,
    city: listingDetails?.city,
    state: listingDetails?.state,
    zip: listingDetails?.zip,
    unit: listingDetails?.unit,
  });

  const updateMutation = useMultiEditMutation();

  const unitField = useFieldSave({
    fieldName: inputName,
    initialValue: initialUnit,
    mutation: updateMutation,
    buildMutationVariables: (value) => ({
      postData: {
        property: {
          listingAlias,
          unit: value,
        },
      },
    }),
  });

  return (
    <div data-testid="AddressFormField">
      <Box css={{ display: 'flex', flexDirection: 'column', gap: '600' }}>
        <RMWInput
          disabled={isInputDisabled}
          readOnly={true}
          description="Street address cannot be edited. You can create a new property with the correct address."
          initialValue={formattedAddressWithoutUnit}
          label="Street address"
        />

        <RMWInput
          disabled={isInputDisabled}
          description="If the property doesn’t have a unit number, leave this field blank"
          errorMessage={unitField.error ?? ''}
          fieldName={inputName}
          initialValue={unitField.value}
          label="Unit number"
          maxLength="20"
          inputType="adorned"
          leftAdornment="#"
          onChange={(e) => unitField.onChange(e.target.value)}
          onBlur={unitField.onBlur}
        />
      </Box>
    </div>
  );
};

export default AddressFormField;
